import { gatewayClient } from '../utils/gatewayClient';

export const getSAMLAssert = ({
  accountId,
  page,
}: {
  accountId: string;
  page: string;
}) =>
  gatewayClient.get(`/api/v2/employee/alegeus/authenticate`, {
    params: accountId
      ? { redirect: `/Page/${page}?accountId=${accountId}` }
      : {},
  });

export const login = ({
  email,
  password,
  recaptcha,
}: {
  email?: string;
  password: string;
  recaptcha?: string | null;
}) =>
  gatewayClient
    .post(`/auth/v2/login/password`, {
      email,
      password,
      recaptcha,
    })
    .then(({ data }) => data);

export const sso = ({ email }: { email?: string }) =>
  gatewayClient
    .post(`/auth/v2/login/identify`, {
      email,
    })
    .then(({ data }) => data);

export const generateMagicLink = ({ email }: { email?: string }) =>
  gatewayClient
    .post(`/auth/v2/login/magic`, {
      email,
    })
    .then(({ data }) => data);

export const generateResetLink = ({ email }: { email?: string }) =>
  gatewayClient
    .post(`/auth/v2/login/reset`, {
      email,
    })
    .then(({ data }) => data);
